import React from 'react';

const CherreGraph: React.FC = () => {
  return <img src={'/assets/cherre_graph.svg'} width='100%' />;
};

CherreGraph.displayName = 'CherreGraph';

export default CherreGraph;
